// extracted by mini-css-extract-plugin
export default {"defaults":"TextInput_defaults__Icraa","big":"TextInput_big__4c6cj","small":"TextInput_small__Z12sv","medium":"TextInput_medium__P8B-9"};